import esCH from './es-ch';
import ptBR from './pt-br';

export default {
  'pt-br': ptBR,
  'es-ch': esCH,
};
